import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  minHeight: '100vh',
  '& .EPImage': {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
  '& .EPTransparent': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(180deg, ${alpha(
      theme.palette.common.black,
      0.2,
    )} 0%, ${theme.palette.common.black} 100%)`,
    zIndex: 1,
  },
  '& .EPContent': {
    position: 'relative',
    color: theme.palette.common.white,
    zIndex: 2,
    textAlign: 'center',
  },
  '& .EPStatusCodeTxt': {
    lineHeight: '100%',
    marginBottom: theme.spacing(4),
    fontSize: theme.spacing(22.5),
    fontWeight: 1000,
    opacity: 0.9,
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.spacing(11.25),
    },
  },
  '& .EPDescription': {
    color: theme.palette.text.secondary,
  },
  '& .EPTitle': {
    textTransform: 'uppercase',
  },
}));

export default StyledBox;
